import makeStyles from '@mui/styles/makeStyles';

const useChangePasswordPageStyles = makeStyles({
  root: {}
});

export default useChangePasswordPageStyles;
